import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Trophy, Medal, Flame, Users } from 'lucide-react';

export default function AlunoRankingPage() {
  const [data, setData] = useState(null);
  const [tipo, setTipo] = useState('turma');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/aluno/ranking')
      .then(res => setData(res.data))
      .finally(() => setLoading(false));
  }, []);

  const ranking = tipo === 'turma'
    ? data?.ranking_turma || []
    : data?.ranking_geral || [];

  const posicao = tipo === 'turma'
    ? data?.posicao_turma
    : data?.posicao_geral;

  const getIcon = (i) => {
    if (i === 0) return '🥇';
    if (i === 1) return '🥈';
    if (i === 2) return '🥉';
    return `#${i + 1}`;
  };

  if (loading) {
    return <div className="text-zinc-500">Carregando ranking...</div>;
  }

  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-3xl font-black font-['Barlow_Condensed'] tracking-tight uppercase text-white">
            Ranking de Atletas
          </h1>
          <p className="text-sm text-zinc-500">
            Veja sua posição e dispute o topo da Kartal.
          </p>
        </div>

        <Badge className="bg-yellow-500/10 text-yellow-400 border-yellow-500/20">
          <Trophy className="w-4 h-4 mr-1" />
          Sua posição: {posicao ? `#${posicao}` : '-'}
        </Badge>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <button
          onClick={() => setTipo('turma')}
          className={`h-12 rounded-xl border font-bold ${
            tipo === 'turma'
              ? 'bg-[#007AFF]/15 border-[#007AFF]/30 text-[#60A5FA]'
              : 'bg-[#141414] border-[#27272A] text-zinc-400'
          }`}
        >
          Ranking da Turma
        </button>

        <button
          onClick={() => setTipo('geral')}
          className={`h-12 rounded-xl border font-bold ${
            tipo === 'geral'
              ? 'bg-[#007AFF]/15 border-[#007AFF]/30 text-[#60A5FA]'
              : 'bg-[#141414] border-[#27272A] text-zinc-400'
          }`}
        >
          Ranking Geral
        </button>
      </div>

      <Card className="bg-gradient-to-br from-[#141414] to-[#0A0A0A] border-[#27272A]">
        <CardContent className="p-5">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-12 h-12 rounded-2xl bg-yellow-500/10 flex items-center justify-center">
              <Medal className="w-6 h-6 text-yellow-400" />
            </div>

            <div>
              <h2 className="text-xl font-black font-['Barlow_Condensed'] uppercase text-white">
                {tipo === 'turma' ? 'Top da Turma' : 'Top Geral Kartal'}
              </h2>
              <p className="text-sm text-zinc-500">
                XP = contrato + mensalidades pagas + presenças.
              </p>
            </div>
          </div>

          {ranking.length === 0 ? (
            <p className="text-zinc-500 text-sm">Nenhum atleta no ranking.</p>
          ) : (
            <div className="space-y-3">
              {ranking.map((a, i) => (
                <div
                  key={a.id}
                  className={`flex items-center justify-between rounded-2xl p-4 border ${
                    a.voce
                      ? 'bg-[#007AFF]/10 border-[#007AFF]/30'
                      : i < 3
                        ? 'bg-yellow-500/5 border-yellow-500/20'
                        : 'bg-[#141414] border-[#27272A]'
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-11 h-11 rounded-xl bg-[#0A0A0A] border border-[#27272A] flex items-center justify-center text-lg font-black text-white">
                      {getIcon(i)}
                    </div>

                    <div>
                      <p className={`font-bold ${a.voce ? 'text-[#60A5FA]' : 'text-white'}`}>
                        {a.nome} {a.voce ? '(Você)' : ''}
                      </p>

                      <p className="text-xs text-zinc-500 flex items-center gap-3 mt-1">
                        <span className="flex items-center gap-1">
                          <Users className="w-3 h-3" /> {a.presencas} presenças
                        </span>
                        <span>
                          {a.mensalidades_pagas} mensalidade(s)
                        </span>
                      </p>
                    </div>
                  </div>

                  <Badge className="bg-yellow-500/10 text-yellow-400 border-yellow-500/20">
                    <Flame className="w-3.5 h-3.5 mr-1" />
                    {a.xp} XP
                  </Badge>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
